import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Footer = function Footer(_ref) {
  var children = _ref.children;
  return _jsx(FooterWrapper, {
    children: children
  });
};

var FooterWrapper = /*#__PURE__*/_styled("div", true ? {
  target: "egvkpjf0"
} : {
  target: "egvkpjf0",
  label: "FooterWrapper"
})(true ? {
  name: "2uxqqp",
  styles: "display:grid;gap:14px;padding:20px"
} : {
  name: "2uxqqp",
  styles: "display:grid;gap:14px;padding:20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvTW9iaWxlTmF2aWdhdGlvbi9Gb290ZXIvRm9vdGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNZ0MiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9OYXZpZ2F0aW9uMi9Nb2JpbGVOYXZpZ2F0aW9uL0Zvb3Rlci9Gb290ZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBGQywgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBGb290ZXI6IEZDPFByb3BzV2l0aENoaWxkcmVuPiA9ICh7IGNoaWxkcmVuIH0pID0+IDxGb290ZXJXcmFwcGVyPntjaGlsZHJlbn08L0Zvb3RlcldyYXBwZXI+XG5cbmNvbnN0IEZvb3RlcldyYXBwZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBncmlkO1xuICBnYXA6IDE0cHg7XG4gIHBhZGRpbmc6IDIwcHg7XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEZvb3RlclxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Footer;